module.exports = __webpack_public_path__ + "media/application/images/svgs/columns-bfc3c435e8c46b18a7f1f422ab9b8033.svg";